<template>
  <h1>InputTreatment<span v-if="!loaded"> (loading..)</span></h1>

  <div v-if="loaded" class="row">
    <input-treatment v-model="current" @continue="triggerEvent('continue')" />
  </div>

  <div class="row">
    <p><strong>Current value:</strong> {{ current ? current : '(none)' }}</p>
    <p><strong>Has value:</strong> {{ hasValue ? 'True' : 'False' }}</p>
    <button class="btn btn-success" @click="randomizeValue">
      Randomize value
    </button>

    <event-ticks :events="events" :events-active="eventsActive" class="mt-4" />
  </div>
</template>

<script>


import { mapState } from 'pinia';
import { useSurveyStore } from '@/store';
import InputTreatment from './InputTreatment.vue';
import DevComponentContainer from '../../DevComponent/DevComponentContainer';
import { pickRandom } from '@/utils/arrayUtil';
import EventTicks from '../../DevComponent/EventTicks';
import EventTicksComponentMixin from '../../DevComponent/EventTicksComponentMixin';

export default {
  name: 'InputTreatmentDev',
  components: { InputTreatment, EventTicks },
  extends: DevComponentContainer,
  mixins: [EventTicksComponentMixin],
  data() {
    return {
      current: null,
      loaded: false,

      events: ['continue'],
    };
  },
  computed: {
    ...mapState(useSurveyStore, ['treatmentCategories']),
    hasValue() {
      return this.current !== null && this.current.length > 0;
    },
  },
  mounted() {
    if (!this.treatmentCategories || !this.treatmentCategories.length) {
      this.$apiClient.misc.getGameData().then((gameData) => {
        useSurveyStore().setTreatmentCategories(gameData.treatmentCategories);

        this.randomizeValue();

        this.$nextTick(() => {
          this.loaded = true;
        });
      });
    } else {
      this.loaded = true;
    }
  },
  methods: {
    randomizeValue() {
      const current = [];
      const maxReturnedItems = 10;

      for (const treatmentCategory of this.treatmentCategories) {
        for (const treatment of treatmentCategory.items) {
          if (current.length >= maxReturnedItems) {
            break;
          }

          if (Math.random() <= 0.5) {
            current.push(treatment.id);
          }
        }
      }

      this.current = current;
    },
  },
};
</script>
